/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { FaSpinner, FaFileExcel, FaFilePdf } from "react-icons/fa";
import { MdRefresh } from "react-icons/md";
import { IoMdSearch, IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { API_URL_AUTH, API_URL_PAY, API_PAYMENT_DOWNLOAD, API_PAYMENT_DOWNLOAD_PDF } from "../../config";
import api from "../../config/api";
import LoadingPage from "../Loading";
import Swal from "sweetalert2";
import noDataImage from "../../assets/images/5274708.jpg";

const Laporan = () => {
  const today = new Date();

  const formatDate = (date) => {
    const pad = (num) => num.toString().padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  };

  const convertDate = (date, isEndDate = false) => {
    // Parse date as local time to avoid UTC issues
    const [year, month, day] = date.split('-').map(Number);
    let dateConv = new Date(year, month - 1, day); // months are 0-indexed
    if (isEndDate) {
      dateConv.setHours(23, 59, 59, 999);
    }
    return dateConv.getTime();
  };

  const formatCreatedAt = (createdAt) => {
    const date = new Date(createdAt);
    const pad = (num) => num.toString().padStart(2, "0");
    return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;
  };

  const [dataOutlet, setDataOutlet] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [startDate, setStartDate] = useState(formatDate(today));
  const [endDate, setEndDate] = useState(formatDate(today));
  const [paymentData, setPaymentData] = useState([]);
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [totalPage, setTotalPage] = useState(0);

  const [loading, setLoading] = useState({
    paymentData: true,
    downloadExcel: false,
    downloadPdf: false,
  });

  // Flatten the outlet groups for the dropdown
  const flatOutlets = dataOutlet.flatMap((group) => group.data);

  // === Function Ambil Data ===
  const _handleSearch = () => {
    setPage(0);
    getPaymentData(0);
    setSearchTrigger((prev) => prev + 1);
  };

  const getDataOutlet = async () => {
    try {
      const response = await api.get(`${API_URL_AUTH}/mopsimapp/all-outlet-group`);
      setDataOutlet(response.data.data);
      // Set first outlet as default ONLY if selectedOutlet is empty
      const flatOutlets = response.data.data.flatMap((group) => group.data);
      if (flatOutlets.length > 0 && !selectedOutlet) {
        const firstOutletId = flatOutlets[0].id;
        setSelectedOutlet(firstOutletId);
        // Call getPaymentData after setting default outlet
        setTimeout(() => {
          getPaymentData(0);
        }, 0);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getPaymentData = async (currentPage = page) => {
    try {
      setLoading((prev) => ({ ...prev, paymentData: true }));
      const dateFirst = convertDate(startDate);
      const dateSecond = convertDate(endDate, true);
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/payment?outlet=${selectedOutlet || ""}&date_first=${dateFirst}&date_second=${dateSecond}&page=${currentPage}&limit=${limit}`
      );
      setPaymentData(response.data.data || []);
      // Set pagination data from response
      if (response.data.page !== undefined) setPage(response.data.page);
      if (response.data.totalRows !== undefined) setTotalRows(response.data.totalRows);
      if (response.data.totalPage !== undefined) setTotalPage(response.data.totalPage);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, paymentData: false }));
    }
  };

  const handleDownload = async (format) => {
    try {
      if (format === 'excel') {
        setLoading((prev) => ({ ...prev, downloadExcel: true }));
      } else {
        setLoading((prev) => ({ ...prev, downloadPdf: true }));
      }
      // Get selected outlet name
      const selectedOutletData = flatOutlets.find(outlet => outlet.id === selectedOutlet);
      const outletName = selectedOutletData ? selectedOutletData.namaOutlet : "semua-outlet";
      const filename = `laporan-psikologisim-${outletName}.${format === 'excel' ? 'xlsx' : 'pdf'}`;
      
      // Show Swal progress
      Swal.fire({
        title: `Download ${format === 'excel' ? 'Excel' : 'PDF'}`,
        html: `
          <div class="flex flex-col items-center gap-2">
            <div class="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
              <div id="progress-bar" class="h-full bg-teal-600 transition-all duration-300" style="width: 0%"></div>
            </div>
            <span id="progress-text" class="text-lg font-semibold">0%</span>
          </div>
        `,
        icon: undefined,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          // Nothing needed here since we hide loading
        }
      });
      
      // Record start time
      const startTime = Date.now();
      
      // Use backend API with api client to pass token and get as blob
      const endpoint = format === 'excel' ? API_PAYMENT_DOWNLOAD : API_PAYMENT_DOWNLOAD_PDF;
      const response = await api.get(
        `${endpoint}?outlet=${selectedOutlet || ""}&date_first=${convertDate(startDate)}&date_second=${convertDate(endDate, true)}`,
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded * 100) / (progressEvent.total || progressEvent.loaded));
            const progressBar = document.getElementById('progress-bar');
            const progressText = document.getElementById('progress-text');
            if (progressBar) {
              progressBar.style.width = `${progress}%`;
            }
            if (progressText) {
              progressText.textContent = `${progress}%`;
            }
          }
        }
      );
      
      // Calculate elapsed time
      const elapsedTime = Date.now() - startTime;
      // Ensure minimum display time of 2 seconds
      const minimumDisplayTime = 2000;
      if (elapsedTime < minimumDisplayTime) {
        await new Promise(resolve => setTimeout(resolve, minimumDisplayTime - elapsedTime));
      }
      
      // Create download link from blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      // Close Swal
      Swal.fire({
        icon: 'success',
        title: 'Download selesai!',
        timer: 1500,
        showConfirmButton: false
      });
    } catch (error) {
      console.log(error.message);
      Swal.fire({
        icon: 'error',
        title: 'Download gagal',
        text: error.message || 'Terjadi kesalahan saat download'
      });
    } finally {
      if (format === 'excel') {
        setLoading((prev) => ({ ...prev, downloadExcel: false }));
      } else {
        setLoading((prev) => ({ ...prev, downloadPdf: false }));
      }
    }
  };

  // === useEffect Awal ===
  useEffect(() => {
    getDataOutlet();
  }, []);

  return (
    <>
      <div className="min-h-screen h-full p-4 bg-gradient-to-b from-gray-300 to-teal-800">
        <h1 className="font-bold text-xl md:text-2xl mb-4 text-amber-700">
          Laporan
        </h1>
        <div className="flex flex-col md:flex-row w-full gap-3 field-body mb-4">
          <div className="w-full md:w-1/4">
            <label htmlFor="outlet" className="block mb-1 font-medium">Outlet</label>
            <select
              id="outlet"
              value={selectedOutlet}
              onChange={(e) => setSelectedOutlet(e.target.value)}
              className="input is-small w-full border-1 border-secondary hover:border-secondary/90 rounded-lg bg-gray-200"
            >
              <option value="">Semua Outlet</option>
              {flatOutlets.map((outlet) => (
                <option key={outlet.id} value={outlet.id}>
                  {outlet.namaOutlet}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full md:w-1/5">
            <label htmlFor="start-date" className="block mb-1 font-medium">Dari Tanggal</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="input is-small w-full border-1 border-secondary hover:border-secondary/90 rounded-lg bg-gray-200"
            />
          </div>
          <div className="w-full md:w-1/5">
            <label htmlFor="end-date" className="block mb-1 font-medium">Sampai Tanggal</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              min={startDate}
              className="input is-small w-full hover:border-secondary/90 rounded-lg bg-gray-200"
            />
          </div>
          <div className="grid grid-cols-4 gap-2 md:w-auto md:flex-1">
            <button
              onClick={() => window.location.reload()}
              className="btn md:mt-6 px-3 py-1.5 rounded-lg flex justify-center items-center gap-2 bg-amber-700 text-white hover:scale-95"
            >
              <MdRefresh /> Refresh
            </button>
            <button
              onClick={() => _handleSearch()}
              disabled={loading.paymentData}
              className="btn md:mt-6 px-3 py-1.5 rounded-lg flex justify-center items-center gap-2 bg-gradient-to-b from-gray-600 to-teal-800 text-white hover:scale-95 disabled:opacity-50"
            >
              {loading.paymentData ? (
                <>
                  <FaSpinner className="animate-spin" color="light" />
                  Loading
                </>
              ) : (
                <>
                  <IoMdSearch /> Cari
                </>
              )}
            </button>
            <button
              onClick={() => handleDownload('excel')}
              disabled={loading.downloadExcel}
              className="btn md:mt-6 px-3 py-1.5 rounded-lg flex justify-center items-center gap-2 bg-green-700 text-white hover:scale-95 disabled:opacity-50"
            >
              {loading.downloadExcel ? (
                <>
                  <FaSpinner className="animate-spin" />
                  Loading
                </>
              ) : (
                <>
                  <FaFileExcel /> Excel
                </>
              )}
            </button>
            <button
              onClick={() => handleDownload('pdf')}
              disabled={loading.downloadPdf}
              className="btn md:mt-6 px-3 py-1.5 rounded-lg flex justify-center items-center gap-2 bg-red-700 text-white hover:scale-95 disabled:opacity-50"
            >
              {loading.downloadPdf ? (
                <>
                  <FaSpinner className="animate-spin" />
                  Loading
                </>
              ) : (
                <>
                  <FaFilePdf /> PDF
                </>
              )}
            </button>
          </div>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-lg shadow">
            <thead className="bg-gradient-to-b from-gray-800 to-teal-800 text-white">
              <tr>
                <th className="px-4 py-2 text-left">NO</th>
                <th className="px-4 py-2 text-left">TANGGAL PENDAFTARAN</th>
                <th className="px-4 py-2 text-left">NAMA PEMOHON</th>
                <th className="px-4 py-2 text-left">NO KTP</th>
                <th className="px-4 py-2 text-left">GOL SIM</th>
                <th className="px-4 py-2 text-left">NO. REG MLD</th>
              </tr>
            </thead>
            <tbody>
              {loading.paymentData ? (
                Array.from({ length: limit }).map((_, index) => (
                  <tr key={index} className="border-b border-gray-200">
                    {Array.from({ length: 6 }).map((_, colIndex) => (
                      <td key={colIndex} className="px-4 py-2">
                        <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                      </td>
                    ))}
                  </tr>
                ))
              ) : paymentData.length === 0 ? (
                <tr>
                  <td colSpan="6">
                    <div className="flex justify-center items-center py-12">
                      <div className="text-center">
                        <div className="flex justify-center mb-4">
                          <img src={noDataImage} alt="Data tidak ditemukan" className="w-40 h-40 object-contain opacity-80" />
                        </div>
                        <h2 className="text-gray-600 font-semibold">
                          Data tidak ditemukan
                        </h2>
                        <p className="text-gray-500">
                          Silakan klik tombol refresh atau cari kembali
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : (
                paymentData.map((item, index) => (
                  <tr key={index} className="border-b border-gray-200">
                    <td className="px-4 py-2">{(page * limit) + index + 1}</td>
                    <td className="px-4 py-2">{formatCreatedAt(item.createdAt)}</td>
                    <td className="px-4 py-2">{item.namaPemohon}</td>
                    <td className="px-4 py-2">{item.nik}</td>
                    <td className="px-4 py-2">{item.kategoriSim}</td>
                    <td className="px-4 py-2">{item.nomorTes}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {(!loading.paymentData && paymentData.length > 0) && (
          <>
            {/* Pagination */}
            {totalRows > 0 && (
              <div className="flex flex-col md:flex-row justify-between items-center mt-6 gap-4">
                <div className="text-white font-medium">
                  Total {totalRows} data • Halaman {page + 1} dari {totalPage}
                </div>
                <div className="flex gap-2 flex-wrap justify-center">
                  <button
                    onClick={() => {
                      if (page > 0) {
                        setPage(page - 1);
                        getPaymentData(page - 1);
                      }
                    }}
                    disabled={page === 0}
                    className="btn px-4 py-2 rounded-lg bg-gradient-to-b from-gray-600 to-teal-800 text-white hover:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <span className="hidden md:inline">&lt; Sebelumnya</span>
                    <IoIosArrowBack className="md:hidden" />
                  </button>
                  
                  {/* Generate pagination items */}
                  {(() => {
                    const items = [];
                    const maxVisible = 5;
                    
                    if (totalPage <= maxVisible) {
                      // Show all pages if few
                      for (let i = 0; i < totalPage; i++) {
                        items.push(
                          <button
                            key={i}
                            onClick={() => {
                              setPage(i);
                              getPaymentData(i);
                            }}
                            disabled={page === i}
                            className={`btn px-4 py-2 rounded-lg ${page === i ? "bg-amber-700" : "bg-gradient-to-b from-gray-600 to-teal-800"} text-white hover:scale-95 disabled:cursor-not-allowed`}
                          >
                            {i + 1}
                          </button>
                        );
                      }
                    } else {
                      // Always show first page
                      items.push(
                        <button
                          key={0}
                          onClick={() => {
                            setPage(0);
                            getPaymentData(0);
                          }}
                          disabled={page === 0}
                          className={`btn px-4 py-2 rounded-lg ${page === 0 ? "bg-amber-700" : "bg-gradient-to-b from-gray-600 to-teal-800"} text-white hover:scale-95 disabled:cursor-not-allowed`}
                        >
                          1
                        </button>
                      );
                      
                      const startPage = Math.max(1, page - 1);
                      const endPage = Math.min(totalPage - 2, page + 1);
                      
                      if (startPage > 1) {
                        items.push(<span key="ellipsis1" className="px-2 text-white flex items-center">...</span>);
                      }
                      
                      // Show pages around current
                      for (let i = startPage; i <= endPage; i++) {
                        items.push(
                          <button
                            key={i}
                            onClick={() => {
                              setPage(i);
                              getPaymentData(i);
                            }}
                            disabled={page === i}
                            className={`btn px-4 py-2 rounded-lg ${page === i ? "bg-amber-700" : "bg-gradient-to-b from-gray-600 to-teal-800"} text-white hover:scale-95 disabled:cursor-not-allowed`}
                          >
                            {i + 1}
                          </button>
                        );
                      }
                      
                      if (endPage < totalPage - 2) {
                        items.push(<span key="ellipsis2" className="px-2 text-white flex items-center">...</span>);
                      }
                      
                      // Always show last page
                      items.push(
                        <button
                          key={totalPage - 1}
                          onClick={() => {
                            setPage(totalPage - 1);
                            getPaymentData(totalPage - 1);
                          }}
                          disabled={page === totalPage - 1}
                          className={`btn px-4 py-2 rounded-lg ${page === totalPage - 1 ? "bg-amber-700" : "bg-gradient-to-b from-gray-600 to-teal-800"} text-white hover:scale-95 disabled:cursor-not-allowed`}
                        >
                          {totalPage}
                        </button>
                      );
                    }
                    
                    return items;
                  })()}
                  
                  <button
                    onClick={() => {
                      if (page < totalPage - 1) {
                        setPage(page + 1);
                        getPaymentData(page + 1);
                      }
                    }}
                    disabled={page === totalPage - 1}
                    className="btn px-4 py-2 rounded-lg bg-gradient-to-b from-gray-600 to-teal-800 text-white hover:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <span className="hidden md:inline">Selanjutnya &gt;</span>
                    <IoIosArrowForward className="md:hidden" />
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Laporan;
